var _module_exports ="<div class=\"container vpadded\">\n    <div class=\"row hpadded\">\n        <div ng-include src=\"'/app/Main/admin/Admin_Actions.tpl.html'\"></div>\n    </div>\n</div>";;
var path = '/app/Main/admin/admin.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;